import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface TriplePanelProps extends ConfigurationProps {}

const TriplePanel: React.FC<TriplePanelProps> = ({
  materials,
  position,
  scale,
}: TriplePanelProps) => {
  const panelPosition0 = new Vector3(-0.459, 0, 0);
  const panelPosition1 = new Vector3(0.459, 0, 0);
  const panelPosition2 = new Vector3(1.375, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([
        panelPosition0,
        panelPosition1,
        panelPosition2,
      ]),
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Paneel materials={materials} position={positions[0]} index={0} />
      <Paneel materials={materials} position={positions[1]} index={1} />
      <Paneel materials={materials} position={positions[2]} index={2} />
    </group>
  );
};

export default TriplePanel;
